import { Link } from 'react-router-dom';
import Breadcrumb from '../components/sections/Breadcrumb';
import TestimonialSection from '../components/sections/TestimonialSection';
import PartnersSection from '../components/sections/PartnersSection';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Breadcrumb title="About Us" subtitle="ABOUT US" />

      {/* Hero Section */}
      <section 
        className="py-12 md:py-20 bg-white"
        style={{
          padding: '3rem 0',
          backgroundColor: '#ffffff'
        }}
      >
        <div 
          className="container mx-auto px-4"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 1rem'
          }}
        >
          <div 
            className="max-w-6xl mx-auto"
            style={{
              maxWidth: '72rem',
              margin: '0 auto'
            }}
          >
            <div 
              className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                gap: '2rem',
                alignItems: 'center'
              }}
            >
              {/* Left Column - Image */}
              <div 
                className="relative"
                style={{
                  position: 'relative'
                }}
              >
                <img 
                  src="/assets/images/about/TDA2024_182.jpg" 
                  alt="Tanzania Digital Awards Event"
                  className="rounded-xl shadow-xl"
                  style={{
                    borderRadius: '0.75rem',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    width: '100%',
                    height: 'auto'
                  }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = '/assets/webpage/TDA2024_182.jpg';
                  }}
                />
                <div 
                  className="absolute -bottom-6 -right-6 w-32 h-32 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold"
                  style={{
                    position: 'absolute',
                    bottom: '-1.5rem',
                    right: '-1.5rem',
                    width: '8rem',
                    height: '8rem',
                    backgroundColor: '#ffba17',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: '700'
                  }}
                >
                  <div 
                    className="text-center"
                    style={{
                      textAlign: 'center'
                    }}
                  >
                    <div 
                      className="text-3xl"
                      style={{
                        fontSize: '1.875rem'
                      }}
                    >
                      2025
                    </div>
                    <div 
                      className="text-sm"
                      style={{
                        fontSize: '0.875rem'
                      }}
                    >
                      Edition
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - Content */}
              <div>
                <span 
                  className="text-orange-500 font-semibold text-sm uppercase tracking-wider mb-4 block"
                  style={{
                    color: '#ffba17',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    marginBottom: '1rem',
                    display: 'block'
                  }}
                >
                  About Tanzania Digital Awards
                </span>
                <h2 
                  className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight"
                  style={{
                    fontSize: 'clamp(2.25rem, 5vw, 3rem)',
                    fontWeight: '700',
                    color: '#111827',
                    marginBottom: '1.5rem',
                    lineHeight: '1.2'
                  }}
                >
                  Digital Excellence in Tanzania
                </h2>
                <p 
                  className="text-lg text-gray-600 leading-relaxed mb-6"
                  style={{
                    fontSize: '1.125rem',
                    color: '#4B5563',
                    lineHeight: '1.8',
                    marginBottom: '1.5rem'
                  }}
                >
                  Established on 16th January 2020, the Tanzania Digital Awards honours creativity, 
                  innovation and efficacy in harnessing digital space for positive societal changes in Tanzania.
                </p>
                <p 
                  className="text-lg text-gray-600 leading-relaxed mb-8"
                  style={{
                    fontSize: '1.125rem',
                    color: '#4B5563',
                    lineHeight: '1.8',
                    marginBottom: '2rem'
                  }}
                >
                  Our mission is to recognize and celebrate digital innovation, creativity, and excellence 
                  across Tanzania, fostering a culture of technological advancement and digital transformation 
                  that drives positive change in society.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section 
        className="py-20 bg-gray-50"
        style={{
          padding: '5rem 0',
          backgroundColor: '#F9FAFB'
        }}
      >
        <div 
          className="container mx-auto px-4"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 1rem'
          }}
        >
          <div 
            className="max-w-6xl mx-auto"
            style={{
              maxWidth: '72rem',
              margin: '0 auto'
            }}
          >
            <div 
              className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                gap: '3rem',
                alignItems: 'flex-start'
              }}
            >
              {/* Mission */}
              <div 
                className="bg-white p-8 rounded-2xl shadow-lg"
                style={{
                  backgroundColor: 'white',
                  padding: '2rem',
                  borderRadius: '1rem',
                  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                }}
              >
                <div 
                  className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6"
                  style={{
                    width: '4rem',
                    height: '4rem',
                    backgroundColor: '#ffba17',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '1.5rem'
                  }}
                >
                  <i 
                    className="fa-solid fa-bullseye text-white text-2xl"
                    style={{
                      color: 'white',
                      fontSize: '1.5rem'
                    }}
                  ></i>
                </div>
                <h3 
                  className="text-2xl md:text-3xl font-bold text-gray-900 mb-6"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#111827',
                    marginBottom: '1.5rem'
                  }}
                >
                  Our Mission
                </h3>
                <p 
                  className="text-lg text-gray-600 leading-relaxed"
                  style={{
                    fontSize: '1.125rem',
                    color: '#4B5563',
                    lineHeight: '1.8'
                  }}
                >
                  To recognize and celebrate digital innovation, creativity, and excellence across Tanzania, 
                  fostering a culture of technological advancement and digital transformation that drives 
                  positive change in society.
                </p>
              </div>

              {/* Vision */}
              <div 
                className="bg-white p-8 rounded-2xl shadow-lg"
                style={{
                  backgroundColor: 'white',
                  padding: '2rem',
                  borderRadius: '1rem',
                  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
                }}
              >
                <div 
                  className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6"
                  style={{
                    width: '4rem',
                    height: '4rem',
                    backgroundColor: '#2563EB',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '1.5rem'
                  }}
                >
                  <i 
                    className="fa-solid fa-eye text-white text-2xl"
                    style={{
                      color: 'white',
                      fontSize: '1.5rem'
                    }}
                  ></i>
                </div>
                <h3 
                  className="text-2xl md:text-3xl font-bold text-gray-900 mb-6"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#111827',
                    marginBottom: '1.5rem'
                  }}
                >
                  Our Vision
                </h3>
                <p 
                  className="text-lg text-gray-600 leading-relaxed"
                  style={{
                    fontSize: '1.125rem',
                    color: '#4B5563',
                    lineHeight: '1.8'
                  }}
                >
                  To become the premier platform that showcases Tanzania's digital excellence, 
                  inspiring innovation and recognizing the visionaries who are building the 
                  digital future of our nation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section 
        className="py-20 bg-white"
        style={{
          padding: '5rem 0',
          backgroundColor: '#ffffff'
        }}
      >
        <div 
          className="container mx-auto px-4"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 1rem'
          }}
        >
          <div 
            className="max-w-6xl mx-auto"
            style={{
              maxWidth: '72rem',
              margin: '0 auto'
            }}
          >
            <div 
              className="text-center mb-16"
              style={{
                textAlign: 'center',
                marginBottom: '4rem'
              }}
            >
              <span 
                className="text-orange-500 font-semibold text-sm uppercase tracking-wider mb-4 block"
                style={{
                  color: '#ffba17',
                  fontWeight: '600',
                  fontSize: '0.875rem',
                  letterSpacing: '0.05em',
                  textTransform: 'uppercase',
                  marginBottom: '1rem',
                  display: 'block'
                }}
              >
                Our Values
              </span>
              <h2 
                className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
                style={{
                  fontSize: 'clamp(2.25rem, 5vw, 3rem)',
                  fontWeight: '700',
                  color: '#111827',
                  marginBottom: '1.5rem',
                  lineHeight: '1.2'
                }}
              >
                What Drives Us
              </h2>
              <p 
                className="text-xl text-gray-600 max-w-3xl mx-auto"
                style={{
                  fontSize: '1.25rem',
                  color: '#4B5563',
                  maxWidth: '48rem',
                  margin: '0 auto',
                  lineHeight: '1.75'
                }}
              >
                Our core values guide everything we do in recognizing digital excellence across Tanzania.
              </p>
            </div>

            <div 
              className="grid grid-cols-1 md:grid-cols-3 gap-8"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '2rem'
              }}
            >
              {/* Innovation */}
              <div 
                className="text-center p-6 bg-gray-50 rounded-xl hover:shadow-lg transition-all duration-300"
                style={{
                  textAlign: 'center',
                  padding: '1.5rem',
                  backgroundColor: '#F9FAFB',
                  borderRadius: '0.75rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div 
                  className="w-20 h-20 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6"
                  style={{
                    width: '5rem',
                    height: '5rem',
                    backgroundColor: '#ffba17',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.5rem'
                  }}
                >
                  <i 
                    className="fa-solid fa-lightbulb text-white text-3xl"
                    style={{
                      color: 'white',
                      fontSize: '1.875rem'
                    }}
                  ></i>
                </div>
                <h3 
                  className="text-2xl font-bold text-gray-900 mb-4"
                  style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: '#111827',
                    marginBottom: '1rem'
                  }}
                >
                  Innovation
                </h3>
                <p 
                  className="text-gray-600 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    lineHeight: '1.75'
                  }}
                >
                  We celebrate groundbreaking ideas and solutions that push the boundaries 
                  of what's possible in the digital space.
                </p>
              </div>

              {/* Excellence */}
              <div 
                className="text-center p-6 bg-gray-50 rounded-xl hover:shadow-lg transition-all duration-300"
                style={{
                  textAlign: 'center',
                  padding: '1.5rem',
                  backgroundColor: '#F9FAFB',
                  borderRadius: '0.75rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div 
                  className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6"
                  style={{
                    width: '5rem',
                    height: '5rem',
                    backgroundColor: '#2563EB',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.5rem'
                  }}
                >
                  <i 
                    className="fa-solid fa-trophy text-white text-3xl"
                    style={{
                      color: 'white',
                      fontSize: '1.875rem'
                    }}
                  ></i>
                </div>
                <h3 
                  className="text-2xl font-bold text-gray-900 mb-4"
                  style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: '#111827',
                    marginBottom: '1rem'
                  }}
                >
                  Excellence
                </h3>
                <p 
                  className="text-gray-600 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    lineHeight: '1.75'
                  }}
                >
                  We recognize and reward the highest standards of quality and performance 
                  in digital solutions and services.
                </p>
              </div>

              {/* Impact */}
              <div 
                className="text-center p-6 bg-gray-50 rounded-xl hover:shadow-lg transition-all duration-300"
                style={{
                  textAlign: 'center',
                  padding: '1.5rem',
                  backgroundColor: '#F9FAFB',
                  borderRadius: '0.75rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div 
                  className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6"
                  style={{
                    width: '5rem',
                    height: '5rem',
                    backgroundColor: '#059669',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.5rem'
                  }}
                >
                  <i 
                    className="fa-solid fa-heart text-white text-3xl"
                    style={{
                      color: 'white',
                      fontSize: '1.875rem'
                    }}
                  ></i>
                </div>
                <h3 
                  className="text-2xl font-bold text-gray-900 mb-4"
                  style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: '#111827',
                    marginBottom: '1rem'
                  }}
                >
                  Impact
                </h3>
                <p 
                  className="text-gray-600 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    lineHeight: '1.75'
                  }}
                >
                  We value solutions that create meaningful, positive change in society 
                  and contribute to Tanzania's development.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section 
        className="py-20 bg-gray-900 relative overflow-hidden"
        style={{
          padding: '5rem 0',
          backgroundColor: '#111827',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <div 
          className="absolute inset-0 opacity-20"
          style={{
            position: 'absolute',
            inset: '0',
            opacity: '0.2',
            backgroundImage: 'url("/assets/webpage/TDA2024_182.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div 
          className="container mx-auto px-4 relative z-10"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 1rem',
            position: 'relative',
            zIndex: '10'
          }}
        >
          <div 
            className="max-w-4xl mx-auto text-center"
            style={{
              maxWidth: '56rem',
              margin: '0 auto',
              textAlign: 'center'
            }}
          >
            <h2 
              className="text-4xl md:text-5xl font-bold text-white mb-8"
              style={{
                fontSize: 'clamp(2.25rem, 5vw, 3rem)',
                fontWeight: '700',
                color: 'white',
                marginBottom: '2rem',
                lineHeight: '1.2'
              }}
            >
              Experience the Tanzania Digital Awards
            </h2>
            <div 
              className="aspect-w-16 aspect-h-9 rounded-2xl overflow-hidden shadow-2xl"
              style={{
                position: 'relative',
                paddingBottom: '56.25%', /* 16:9 aspect ratio */
                borderRadius: '1rem',
                overflow: 'hidden',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
              }}
            >
              <iframe 
                src="https://www.youtube.com/embed/Fawf7FJifEo?autoplay=0&controls=1&rel=0" 
                title="Tanzania Digital Awards Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <TestimonialSection />

      {/* Partners Section */}
      <PartnersSection />

      {/* Contact CTA */}
      <section 
        className="py-20 bg-gradient-to-r from-blue-900 to-blue-800"
        style={{
          padding: '5rem 0',
          background: 'linear-gradient(90deg, #0f1b3c 0%, #1a2d5c 100%)'
        }}
      >
        <div 
          className="container mx-auto px-4 text-center"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 1rem',
            textAlign: 'center'
          }}
        >
          <div 
            className="max-w-4xl mx-auto"
            style={{
              maxWidth: '56rem',
              margin: '0 auto'
            }}
          >
            <h2 
              className="text-4xl md:text-5xl font-bold text-white mb-6"
              style={{
                fontSize: 'clamp(2.25rem, 5vw, 3rem)',
                fontWeight: '700',
                color: 'white',
                marginBottom: '1.5rem',
                lineHeight: '1.2'
              }}
            >
              Ready to Get Involved?
            </h2>
            <p 
              className="text-xl text-gray-300 mb-8 leading-relaxed"
              style={{
                fontSize: '1.25rem',
                color: '#D1D5DB',
                marginBottom: '2rem',
                lineHeight: '1.75'
              }}
            >
              Join us in celebrating digital excellence across Tanzania. Whether you want to nominate, 
              learn more, or get involved, we'd love to hear from you.
            </p>
            <div 
              className="flex flex-col sm:flex-row gap-4 justify-center"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                gap: '1rem',
                flexWrap: 'wrap'
              }}
            >
              <a 
                href="mailto:info@digitalawards.co.tz"
                className="inline-flex items-center px-8 py-4 bg-orange-500 text-white rounded-full font-semibold text-lg hover:bg-orange-600 transition-all duration-300"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '1rem 2rem',
                  backgroundColor: '#ffba17',
                  color: 'white',
                  borderRadius: '9999px',
                  fontWeight: '600',
                  fontSize: '1.125rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                <i 
                  className="fa-solid fa-envelope mr-3"
                  style={{
                    marginRight: '0.75rem'
                  }}
                ></i>
                Contact Us
              </a>
              <Link 
                to="/nominate"
                className="inline-flex items-center px-8 py-4 bg-white text-gray-900 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '1rem 2rem',
                  backgroundColor: 'white',
                  color: '#111827',
                  borderRadius: '9999px',
                  fontWeight: '600',
                  fontSize: '1.125rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                <i 
                  className="fa-solid fa-trophy mr-3"
                  style={{
                    marginRight: '0.75rem'
                  }}
                ></i>
                Nominate Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;